import { type StateCreator } from 'zustand';

export type LastThreadEntry = {
  lastAccessed: number;
  threadId: string;
};

export type LastThreadSlice = {
  lastThreadByResource: Record<string, LastThreadEntry>;
  getLastThread: (resourceId: string) => string | undefined;
  setLastThread: (resourceId: string, threadId: string) => void;
};

export type CreateLastThreadSlice = () => StateCreator<LastThreadSlice, [], [], LastThreadSlice>;

export const createLastThreadSlice: CreateLastThreadSlice = () => (set, get) => ({
  getLastThread: (resourceId) => get().lastThreadByResource[resourceId]?.threadId,
  lastThreadByResource: {},
  setLastThread: (resourceId, threadId) =>
    set((state) => ({
      lastThreadByResource: {
        ...state.lastThreadByResource,
        [resourceId]: { lastAccessed: Date.now(), threadId },
      },
    })),
});
